export default __webpack_public_path__ + "static/project-slide-8-2016-765-ca0275baf08bc7765467ce4098be0fc8.webp";